export var EStarTheme;
(function (EStarTheme) {
  EStarTheme["Fillable"] = "fillable";
  EStarTheme["Filled"] = "filled";
  EStarTheme["NotFilled"] = "notFilled";
})(EStarTheme || (EStarTheme = {}));
export var EStarSize;
(function (EStarSize) {
  EStarSize["S"] = "s";
  EStarSize["M"] = "m";
})(EStarSize || (EStarSize = {}));